export const enum ResidenceTypes_enum {
  PRODUCT = "product",
  ROOM = "room",
}

export const enum Residence_Product_Types_enum { // This is 'product' types. Not 'room' types;
  BOOMGARDI = "boomgardi",
  SUIT = "suit",
  HOTEL = "hotel", // correct
}
